export { TestimonialSolo } from './TestimonialSolo';
export type { Props as TestimonialSoloProps } from './TestimonialSolo';
